import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { Button, Dialog, LinearProgress, TextField } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import API from 'app/API';
import useStores from 'hooks/use-stores';

const RecoverPassword: React.FC = () => {
    const { dialogStore } = useStores();
    const { openLoginDialog, recoveryDialogOpen } = dialogStore;

    const [state, setState] = useState({
        email: '',
        errorText: '',
        loading: false
    });

    const handleEmailChange = (event) => setState((state) => ({ ...state, email: event.target.value }));

    const onRecovery = () => {
        setState((state) => ({ ...state, loading: true }));
        API.fetchWithToken(API.SEND_RECOVERY, {
            email: state.email
        }).then((response) => {
            setState((state) => ({
                ...state,
                loading: false,
                errorText: response.result === 'error' ? response.data.error : ''
            }));

            if (response.result === 'OK') {
                dialogStore.openMessageDialog(
                    'Recover your access',
                    'Message with access recovery link was sent to your email'
                );
            }
        });
    };

    return (
        <Dialog maxWidth="xs" open={recoveryDialogOpen} onClose={openLoginDialog} className="vulners-dialog">
            <DialogTitle>{'Recover password'}</DialogTitle>
            <DialogContent>
                <TextField fullWidth name="email" label="Email" onChange={handleEmailChange} />
                <br />
                <div className="vulners-dialog-error-text">{state.errorText}</div>
                {state.loading && <LinearProgress variant="indeterminate" />}
                <Button fullWidth color="primary" variant="contained" onClick={onRecovery} disabled={state.loading}>
                    {'SEND'}
                </Button>
                <br />
            </DialogContent>
        </Dialog>
    );
};

export default observer(RecoverPassword);
